angular.module('impactx.shareLink').service('ShareLinkService', ['$location', '$redirect', '$copyToClipboard', 'ToastService', 'TranslationService', ShareLinkService]);

function ShareLinkService($location, $redirect, $copyToClipboard, ToastService, TranslationService) {

    var self = this;

    var deepLink = $location.absUrl();

    self.shareLinkByMessage = function () {
        $redirect.redirectTo(null, '/message/0', [{deepLink: deepLink}]);
    };

    self.shareLinkByClipboard = function () {
        $copyToClipboard.copy(deepLink).then(function () {
            ToastService.openStandardToast(TranslationService.get("linkSuccessfullyCopied"));
        });
    };

    return {
        shareLinkByMessage: self.shareLinkByMessage,
        shareLinkByClipboard: self.shareLinkByClipboard
    };
}